import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { FaEyeSlash, FaRegEye, FaLock, FaUserAlt } from "react-icons/fa";
import "./LoginPage.css";
import { useAuth } from "../services/AuthContext";


function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    
    if (!emailOrUsername || !password) {
      setError("Email/Username and Password are required.");
      return;
    }
    
    setIsLoading(true);
    
    try {
      const result = await login({ emailOrUsername, password });
      
      if (result.success) {
        navigate("/home", { replace: true });
      } else {
        setError(result.error || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
      
      <div className="login-card">
        <div className="brand-header">
          <h1 className="company-name">SYNERGY MECHANICS</h1>
        </div>
        
        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Please enter your credentials to continue</p>
        
        {error && <div className="alert alert-danger">{error}</div>}
        
        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-4" controlId="formBasicEmail">
            <div className="input-group">
              <span className="input-icon"><FaUserAlt /></span>
              <input
                type="text"
                autoComplete="username"
                value={emailOrUsername}
                onChange={(e) => setEmailOrUsername(e.target.value)}
                className="form-input"
                placeholder="Email or Username"
                required
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-4" controlId="formBasicPassword">
            <div className="input-group">
              <span className="input-icon"><FaLock /></span>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="Password"
                required
              />
              <span
                className="password-toggle"
                onClick={togglePasswordVisibility}
                role="button"
                tabIndex={0}
              >
                {showPassword ? <FaRegEye /> : <FaEyeSlash />}
              </span>
            </div>
          </Form.Group>
          
          <button 
            type="submit" 
            className="login-button" 
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </Form>
      </div>
    </div>
  );
}

export default Login;